import { FC } from "react";
import { IconProps } from "./types";

export const Menu: FC<IconProps> = ({
  className,
  color = "#111",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="22"
      fill="none"
      viewBox="0 0 29 22"
      className={className}
      {...props}
    >
      <path fill={color} d="M12 22h17v-3H12v3zM0 13h29v-3H0v3zm5-9h24V1H5v3z" />
    </svg>
  );
};
